import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TokenStorageService } from './shared/services/token-storage.service';

/**
 * AuthGuard — protects authenticated routes.
 *
 * By the time this guard runs, APP_INITIALIZER has already completed
 * TokenRefreshService.startupRefresh(), so access_token is in memory
 * if the user has a valid session.
 *
 * Guard only redirects to login when there is truly no session
 * (no access_token in memory AND no refresh_token to recover from).
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private storage = inject(TokenStorageService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // access_token is in memory (never localStorage) after APP_INITIALIZER runs.
    // If it's null here, startupRefresh() already tried and failed (no refresh_token
    // or refresh token was rejected by the server) — redirect to login.
    if (!this.storage.accessToken) {
      const returnUrl = state.url;
      this.router.navigate(['login'], { queryParams: { returnUrl } });
      return false;
    }

    return true;
  }
}
